<!--
 * @Author: zerui.yao
 * @Date: 2023-05-24 14:22:57
 * @LastEditors: zerui.yao
 * @LastEditTime: 2023-06-05 18:08:41
 * @FilePath: /fed-authority/src/layouts/HeaderAsideLayout/components/Menu/SideMenu.vue
 * @Description: 
-->
<!-- eslint-disable vue/no-mutating-props -->
<template>
  <a-layout-sider
    v-model="collapsed"
    :class="[
      'sider',
      isDesktop() ? null : 'shadow',
      theme,
      fixSiderbar ? 'ant-fixed-sidemenu' : null,
    ]"
    width="230px"
    :collapsible="collapsible"
    :trigger="null"
  >
    <!-- <logo /> -->
    <div v-if="searchMenu" class="search-menu">
      <a-input-search placeholder="搜索" @change="onSearch" />
    </div>
    <s-menu
      v-if="menus.length > 0"
      :collapsed="collapsed"
      :menu="menus"
      :normal-menu="normalMenus"
      :theme="theme"
      :mode="mode"
      @select="onSelect"
    ></s-menu>
  </a-layout-sider>
</template>

<script>
import { mixin, mixinDevice } from '@/utils/mixin';
// import Logo from '../tools/Logo';
import SMenu from './index';

export default {
  name: 'SideMenu',
  components: { SMenu },
  mixins: [mixin, mixinDevice],
  props: {
    mode: {
      type: String,
      required: false,
      default: 'inline',
    },
    theme: {
      type: String,
      required: false,
      default: 'dark',
    },
    collapsible: {
      type: Boolean,
      required: false,
      default: false,
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false,
    },
    menus: {
      type: Array,
      default: () => [],
      required: true,
    },
    // 无树状普通数组菜单数据
    normalMenus: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  methods: {
    onSelect(obj) {
      this.$emit('menuSelect', obj);
    },
    onSearch(e) {
      const keyword = e.target.value;
      this.$store.commit('system/menu/searchMenu', keyword);
    },
  },
};
</script>
<style lang="less" scoped>
@import '../index';
// 未展开时，不显示
.ant-layout-sider-collapsed .search-menu {
  display: none;
}
// 左侧菜单搜索
.search-menu {
  padding: 16px;
}
/deep/ .ant-menu-item a {
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 20px;
}
</style>
